<template>
  <div class="container" v-if="dataLoaded">
    <div class="level">
      <div class="level-left">
        <div class="level-item" v-if="!showEditFields">
          <h4 class="title is-4">{{ evaluator.fullName }}</h4>
          <h5 class="title is-5" :style="{ marginLeft: '2rem' }">{{ evaluator.email }}</h5>
        </div>
        <div class="level-item" v-if="showEditFields">
          <div class="control is-expanded" :style="{ marginRight: '1rem' }">
            <label class="label">First Name</label>

            <input type="text" class="input" v-model="evaluator.firstName" />
          </div>
          <div class="control is-expanded" :style="{ marginRight: '1rem' }">
            <label class="label">Last Name</label>
            <input type="text" class="input" v-model="evaluator.lastName" />
          </div>
          <div class="control is-expanded">
            <label class="label">Email</label>
            <input type="text" class="input" v-model="evaluator.email" />
          </div>
        </div>
      </div>
      <div class="level-right">
        <div class="level-right">
          <div class="level-item">
            <button class="button" @click="sendEmailToEvaluator(evaluator)">
              Send Individual Email
            </button>
          </div>
          <div class="level-item">
            <button class="button" @click="copyMagicLinkToClipboard()">
              Copy Magic Link
            </button>
          </div>
          <div class="level-item">
            <button class="button" v-if="!showEditFields" @click="showEditFields = !showEditFields">
              Edit
            </button>
          </div>
          <div class="level-item">
            <button class="button is-primary" v-if="showEditFields" @click="saveNotes">
              Save Edits
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="content">
        <h5 class="title is-5">Date Joined: {{ evaluator.dateJoined }}</h5>
      </div>
      <div class="content">
        <h5 class="title is-5">LinkedIn Profile</h5>
        <div v-if="showEditFields">
          <input type="text" class="input" v-model="evaluator.linkedinProfile" />
        </div>
        <p v-if="!showEditFields">{{ evaluator.linkedinProfile }}</p>
      </div>

      <h5 class="title is-5">Status</h5>

      <div class="level">
        <div class="level-left">
          <div class="select">
            <select v-model="newEvaluatorStatus" @change="updateStatus">
              <option v-for="(status, value) in statuses" :key="value" :value="value">{{
                status
              }}</option>
            </select>
          </div>
        </div>
      </div>

      <div class="content">
        <h5 class="title is-5">Organization</h5>
        <div class="select" v-if="showEditFields">
          <select v-model="evaluator.organization">
            <option v-for="org in organizations" :key="org.id" :value="org.id">{{
              org.name
            }}</option>
          </select>
        </div>
        <p v-if="!showEditFields">{{ evaluator.organizationRef.name }}</p>
      </div>

      <h5 class="title is-5">Staff Notes</h5>
      <textarea
        rows="10"
        class="textarea"
        v-model="evaluator.notes"
        v-if="showEditFields"
      ></textarea>
      <div class="box has-background-light" v-if="!showEditFields">
        <span class="evaluator-notes">
          {{ evaluator.notes ? evaluator.notes : 'No staff notes entered' }}
        </span>
      </div>
    </div>
    <div class="content">
      <h5 class="title is-5">What is your primary affiliation?</h5>
      <textarea
        rows="10"
        class="textarea"
        v-model="evaluator.evaluatorAffiliation"
        v-if="showEditFields"
      ></textarea>
      <div class="box has-background-light" v-if="!showEditFields">
        <span class="evaluator-notes">
          {{
            evaluator.evaluatorAffiliation
              ? evaluator.evaluatorAffiliation
              : 'No information entered'
          }}
        </span>
      </div>
    </div>

    <div class="content">
      <h5 class="title is-5">What are your other affiliations?</h5>
      <textarea
        rows="10"
        class="textarea"
        v-model="evaluator.evaluatorOtherAffiliations"
        v-if="showEditFields"
      ></textarea>
      <div class="box has-background-light" v-if="!showEditFields">
        <span class="evaluator-notes">
          {{
            evaluator.evaluatorOtherAffiliations
              ? evaluator.evaluatorOtherAffiliations
              : 'No information entered'
          }}
        </span>
      </div>
    </div>
    <h5 class="title is-5">Why do you want to join?</h5>
    <textarea
      rows="10"
      class="textarea"
      v-model="evaluator.evaluatorWhyJoin"
      v-if="showEditFields"
    ></textarea>
    <div class="box has-background-light" v-if="!showEditFields">
      <span class="evaluator-notes">
        {{ evaluator.evaluatorWhyJoin ? evaluator.evaluatorWhyJoin : 'No information entered' }}
      </span>
    </div>
    <h5 class="title is-5">What are your qualifications?</h5>
    <textarea
      rows="10"
      class="textarea"
      v-model="evaluator.evaluatorQualifications"
      v-if="showEditFields"
    ></textarea>
    <div class="box has-background-light" v-if="!showEditFields">
      <span class="evaluator-notes">
        {{
          evaluator.evaluatorQualifications
            ? evaluator.evaluatorQualifications
            : 'No information entered'
        }}
      </span>
    </div>
    <h5 class="title is-5">How did you find out about us?</h5>
    <textarea
      rows="10"
      class="textarea"
      v-model="evaluator.evaluatorHowFindOut"
      v-if="showEditFields"
    ></textarea>
    <div class="box has-background-light" v-if="!showEditFields">
      <span class="evaluator-notes">
        {{
          evaluator.evaluatorHowFindOut ? evaluator.evaluatorHowFindOut : 'No information entered'
        }}
      </span>
    </div>
    <h5 class="title is-5">What are your main interests?</h5>
    <textarea
      rows="10"
      class="textarea"
      v-model="evaluator.evaluatorMainInterests"
      v-if="showEditFields"
    ></textarea>
    <div class="box has-background-light" v-if="!showEditFields">
      <span class="evaluator-notes">
        {{
          evaluator.evaluatorMainInterests
            ? evaluator.evaluatorMainInterests
            : 'No information entered'
        }}
      </span>
    </div>
    <h5 class="title is-5" v-if="evaluator.assignments.length > 0">Current Assigments</h5>
    <div class="content">
      <ul>
        <li v-for="application in assignedApplications" :key="application.id" >
          <span v-if="application.cohort.id === activeCohorts[0].id">
            <router-link
              :to="{ name: 'NonAssignedApplicationReviewDetail', params: { applicationId: application.id } }"
            target="_blank"
            >{{ application.organization.name }} - ({{application.cohort.name}})</router-link
          >
          </span>
        </li>
      </ul>
    </div>
    <h5 class="title is-5">Completed Evaluations</h5>
    <div class="content">
      <ul>
        <li v-if="completedEvaluations.length === 0">No completed evaluations</li>
        <li v-for="evaluation in completedEvaluations" :key="evaluation.id">
          <router-link
            :to="{
              name: 'NonAssignedApplicationReviewDetail',
              params: { applicationId: evaluation.application.id },
            }"
            target="_blank"
            >{{ evaluation.application.organizationName }} - ({{ allCohorts.find(allcohort => allcohort.id == evaluation.application.cohort).name }})</router-link
          >
        </li>
      </ul>
    </div>
    <h5 class="title is-5">Incomplete Assignments</h5>
    <div class="content">
      <ul>
        <li v-if="startedEvaluations.length === 0">No incomplete evaluations</li>
        <li v-for="evaluation in startedEvaluations" :key="evaluation.id">
          <router-link
            :to="{
              name: 'NonAssignedApplicationReviewDetail',
              params: { applicationId: evaluation.application.id },
            }"
            target="_blank"
            >{{ evaluation.application.organizationName }} - ({{ allCohorts.find(allcohort => allcohort.id == evaluation.application.cohort).name }})</router-link
          >
        </li>
      </ul>
    </div>
    <h5 class="title is-5">Assigned But Did Not Start</h5>
    <div class="content">
      <ul>
        <li v-if="emptyEvaluations.length === 0">No unstarted assignments</li>
        <li v-for="evaluation in emptyEvaluations" :key="evaluation.id">
          <router-link
            :to="{
              name: 'NonAssignedApplicationReviewDetail',
              params: { applicationId: evaluation.application.id },
            }"
            target="_blank"
            >{{ evaluation.application.organizationName }} - ({{ allCohorts.find(allcohort => allcohort.id == evaluation.application.cohort).name }})</router-link
          >
        </li>
      </ul>
    </div>
    <h5 class="title is-5">Follow-Ups</h5>
    <div class="content">
      <ul>
        <li v-for="commitment in commitments" :key="commitment.id">
          <router-link
            :to="{
              name: 'NonAssignedApplicationReviewDetail',
              params: { applicationId: commitment.evaluationRef.application },
            }"
            target="_blank"
            ><strong>{{ commitment.evaluationRef.organizationName }}</strong
            >: {{ commitment.description }} </router-link
          >
        </li>
      </ul>
    </div>

    <div class="content">
      <h5 class="title is-5">Preferences</h5>
      <div class="buttons" v-if="!editPreferences">
        <span
          class="tag"
          style="margin: 0 0.5rem"
          v-for="preference in evaluator.preferencesRef"
          :key="preference.id"
        >
          <router-link
            :to="{
              name: 'EvaluatorOverviewByPreference',
              params: { preferenceId: preference.id },
            }"
          >
            {{ preference.name }}
          </router-link>
        </span>
      </div>
      <div class="buttons" v-if="editPreferences">
        <button
          class="button"
          :class="{ 'is-primary': doesUserHavePreference(preference) }"
          @click="addOrRemovePreference(preference)"
          v-for="preference in preferences"
          :key="preference.id"
        >
          {{ preference.name }}
        </button>
      </div>
      <div class="buttons">
        <button class="button" @click="toggleEditPreferences">Edit Preferences</button>
        <button class="button" @click="savePreferences">Save Preferences</button>
        <button class="button" @click="toggleEditPreferences">Cancel</button>
      </div>
    </div>

    <div class="content">
      <h5 class="title is-5">Tags</h5>
      <div class="buttons" v-if="!editTags">
        <span class="tag" style="margin: 0 0.5rem" v-for="tag in evaluator.tagsRef" :key="tag.id">
          <router-link
            :to="{
              name: 'EvaluatorOverviewByTag',
              params: { tagId: tag.id },
            }"
          >
            {{ tag.name }}
          </router-link>
        </span>
      </div>
      <div class="buttons" v-if="editTags">
        <button
          class="button"
          :class="{ 'is-primary': newTags.includes(tag.id) }"
          @click="addOrRemoveTag(tag)"
          v-for="tag in tags"
          :key="tag.id"
        >
          {{ tag.name }}
        </button>
      </div>
      <div class="buttons">
        <button class="button" @click="toggleEditTags">Edit Tags</button>
        <button class="button" @click="saveTags">Save Tags</button>
        <button class="button" @click="toggleEditTags">Cancel</button>
      </div>
    </div>

    <BulkEmailModal
        v-if="showModal"
        :users="selectedEvaluators"
        @close="showModal = !showModal"
        @submit="refreshData()"
      />

  </div>
</template>

<script>
import copyToClipboard from 'copy-to-clipboard'
import User from '@/services/users'
import Preference from '@/services/preferences'
import Commitment from '@/services/commitments'
import Organization from '@/services/organizations'
import Tag from '@/services/tags'
import Evaluation from '@/services/evaluations'
import Cohort from '@/services/cohorts'
import store from '@/vuex/store'
import BulkEmailModal from '@/components/emails/BulkEmailModal'

export default {
  components: {  BulkEmailModal },
  data() {
    return {
      assignedApplications: [],
      activeCohorts:[],
      allCohorts: [],
      allCohortsPromise: null,
      showEditFields: false,
      commitments: [],
      evaluator: [],
      organizations: [],
      evaluations: [],
      submitButtonLoading: false,
      dataLoaded: false,
      commitmentFilters: {
        submitter: null,
      },
      editPreferences: false,
      preferences: [],
      newPreferences: [],
      editTags: false,
      tags: [],
      newTags: [],
      newEvaluatorStatus: '',
      magicLink: '',
      selectedEvaluators: [],
      selectPage: false,
      showModal: false,
      statuses: User.evaluatorStatuses,
    }
  },
  computed: {
    completedEvaluations() {
      if (!this.evaluations || this.evaluations.length === 0) {
        return []
      }
      const completedEvaluations = this.evaluations.filter(e => e.isCompleted)
      return completedEvaluations
    },
    startedEvaluations() {
      if (!this.evaluations || this.evaluations.length === 0) {
        return []
      }
      const startedEvaluations = this.evaluations.filter(e => !e.isCompleted && !e.isEmpty)
      return startedEvaluations
    },
    emptyEvaluations() {
      if (!this.evaluations || this.evaluations.length === 0) {
        return []
      }
      const emptyEvaluations = this.evaluations.filter(e => !e.isCompleted && e.isEmpty)
      return emptyEvaluations
    },
  },
  async created() {
    this.refreshData()
    this.fetchOrganizations()
    this.fetchTags()
    this.allCohortsPromise = await Cohort.api.list().then(data => {
      this.allCohorts = data.results
      this.activeCohorts = this.allCohorts.filter(cohort => cohort.isActive === true)
      User.api.listApplications(this.$route.params.evaluatorId).then(data => {
        this.assignedApplications = data.filter(
          application => application.cohort.id === this.activeCohorts[0].id,
        )
      })
    })
  },

  methods: {
    toggleEditPreferences() {
      this.editPreferences = !this.editPreferences
    },
    copyMagicLinkToClipboard() {
      //console.log("copyMagicLinkToClipboard");
      const emailURL = `users/${this.evaluator.id}/get-magic-link/`
      const emailPromise = store.getters.apiClient.get(emailURL)
      emailPromise.then(response => {
        const data = response.data
        copyToClipboard(`${data.magic_link}`)
        this.$Alert.alert({
          type: 'info',
          message: `<p>Copied</p>`,
          timeout: 6000,
        })
      })
    },
    savePreferences() {
      const fields = ['preferences']
      let newEvaluator = User.create(this.evaluator)
      newEvaluator.preferences = this.newPreferences
      User.api.update(newEvaluator, fields).then(data => {
        this.editPreferences = false
        this.evaluator = data
        this.newPreferences = [...this.evaluator.preferences]
      })
    },
    sendEmailToEvaluator(evaluator) {
      //console.log("sendEmailToEvaluator");
      if (this.selectPage) {
        this.toggleSelectPage()
      } else {
        this.selectedEvaluators = []
      }
      this.selectedEvaluators = [evaluator]
      this.showModal = true
    },
    toggleSelectPage() {
      //console.log("toggleSelectPage");
      if (this.selectPage) {
        this.selectedEvaluators = [...this.evaluators]
      } else {
        this.selectedEvaluators = []
      }
    },
    addOrRemovePreference(preference) {
      if (this.newPreferences.includes(preference.id)) {
        this.newPreferences = this.newPreferences.filter(p => p !== preference.id)
      } else this.newPreferences.push(preference.id)
    },
    toggleEditTags() {
      this.editTags = !this.editTags
      this.newTags = [...this.evaluator.tags]
    },
    addOrRemoveTag(tag) {
      if (this.newTags.includes(tag.id)) {
        this.newTags = this.newTags.filter(t => t !== tag.id)
      } else {
        this.newTags.push(tag.id)
      }
    },
    saveTags() {
      const fields = ['tags']
      let newEvaluator = User.create(this.evaluator)
      newEvaluator.tags = this.newTags
      User.api.update(newEvaluator, fields).then(data => {
        this.editTags = false
        this.evaluator = data
        this.newTags = [...this.evaluator.tags]
      })
    },
    updateStatus() {
      let newEvaluator = User.create(this.evaluator)
      newEvaluator.status = this.newEvaluatorStatus
      let fields = ['status']
      User.api
        .update(newEvaluator, fields)
        .then(data => {
          this.evaluator = data
          this.$Alert.alert({
            type: 'success',
            message: `<p>Updated Status<p>`,
            timeout: 6000,
          })
        })
        .catch(() => {
          this.$Alert.alert({
            type: 'success',
            message: `<p>Status update failed<p>`,
            timeout: 6000,
          })
          this.newEvaluatorStatus = this.evaluator.status
        })
    },
    refreshData() {
      //console.log("refreshData")
      const evaluatorId = this.$route.params.evaluatorId
      this.commitmentFilters.submitter = evaluatorId
      let preferencePromise = Preference.api.list().then(data => {
        this.preferences = data.results
      })
      let userPromise = User.api.get(evaluatorId).then(data => {
        this.evaluator = data
        this.newEvaluatorStatus = this.evaluator.status
        this.newPreferences = [...this.evaluator.preferences]
        this.newTags = [...this.evaluator.tags]

        const emailURL = `users/${this.evaluator.id}/get-magic-link/`
        const emailPromise = store.getters.apiClient.get(emailURL)
        emailPromise.then(response => {
          const data = response.data
          this.magicLink = data.magic_link
        })
      })
      let commitmentPromise = Commitment.api
        .list({ filters: this.commitmentFilters })
        .then(data => {
          this.commitments = data.results
        })
      let evaluationsPromise = Evaluation.api
        .list({ filters: { evaluator: evaluatorId } })
        .then(response => {
          this.evaluations = response.results
        })

      Promise.all([preferencePromise, userPromise, commitmentPromise, evaluationsPromise]).then(
        () => {
          this.dataLoaded = true
        },
      )
    },
    fetchOrganizations() {
      //console.log("fetchOrganizations")
      Organization.api.list({ filters: { pageSize: 10000 } }).then(response => {
        this.organizations = response.results
      })
      //console.log(this.evaluator)
    },
    fetchTags() {
      //console.log("fetchTags")
      Tag.api.list({ filters: { pageSize: 1000 } }).then(response => {
        this.tags = response.results
      })
      //console.log(this.evaluator)
    },
    doesUserHavePreference(preference) {
      if (!this.dataLoaded) {
        return false
      }
      return this.newPreferences.includes(preference.id)
    },
    saveNotes() {
      const fields = [
        'notes',
        'evaluatorAffiliation',
        'evaluatorOtherAffiliations',
        'evaluatorWhyJoin',
        'evaluatorQualifications',
        'evaluatorHowFindOut',
        'evaluatorMainInterests',
        'organization',
        'firstName',
        'lastName',
        'email',
        'linkedinProfile',
      ]
      User.api.update(this.evaluator, fields).then(data => {
        this.showEditFields = false
        this.evaluator = data
      })
    },
    approveEvaluator(evaluator) {
      let newEvaluator = User.create(evaluator)
      newEvaluator.pendingAsEvaluator = false
      newEvaluator.rejectedAsEvaluator = false
      const fields = ['pendingAsEvaluator', 'rejectedAsEvaluator']
      User.api.update(newEvaluator, fields).then(() => {
        this.refreshData()
      })
    },
    setEvaluatorToPending(evaluator) {
      let newEvaluator = User.create(evaluator)
      newEvaluator.pendingAsEvaluator = true
      newEvaluator.rejectedAsEvaluator = false
      const fields = ['pendingAsEvaluator', 'rejectedAsEvaluator']
      User.api.update(newEvaluator, fields).then(() => {
        this.refreshData()
      })
    },
    rejectEvaluator(evaluator) {
      let newEvaluator = User.create(evaluator)
      newEvaluator.pendingAsEvaluator = false
      newEvaluator.rejectedAsEvaluator = true
      const fields = ['pendingAsEvaluator', 'rejectedAsEvaluator']
      User.api.update(newEvaluator, fields).then(() => {
        this.refreshData()
      })
    },
  },
}
</script>

<style scoped>
.button {
  margin: 10px 10px 0;
}

.evaluator-notes {
  white-space: pre;
  word-wrap: break-word;
  white-space: pre-wrap; /* css-3 */
  white-space: -moz-pre-wrap; /* Mozilla, since 1999 */
  white-space: -pre-wrap; /* Opera 4-6 */
  white-space: -o-pre-wrap; /* Opera 7 */
  word-wrap: break-word; /* Internet Explorer 5.5+ */
}
</style>
